import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';

import { InputProps } from '~components/form-fields';
import Icon, { faChevronDown, faChevronUp } from '~components/icon';
import { TableView } from '~components/table-view-v3';

import columnsFactory from '~support-at-home/forms/budgets/fundingLevelsList';

import { useGetFundingLevelAmountsQuery } from '~lookups/actions/fundingLevelAmounts';

const FundingLevelAmounts: React.FC<InputProps> = ({ value }) => {
  const { start_date, end_date } = value;
  const [isOpen, setIsOpen] = useState(false);

  // RTK Hook
  const { data = [], isFetching: isLoading } = useGetFundingLevelAmountsQuery();

  const columns = columnsFactory(start_date, end_date);

  return (
    <Card className="rounded-0">
      <CardHeader
        className="d-flex justify-content-between border-0 fw-bold align-items-center"
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsOpen(!isOpen);
          }
        }}
      >
        <div>Funding Levels Reference Guide</div>
        <Icon icon={isOpen ? faChevronUp : faChevronDown} className="ms-2" />
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody className="p-0">
          <TableView
            id="funding-level-amounts-table"
            columns={columns}
            data={data}
            isLoading={isLoading}
            readonly
            striped
            bordered
          />
          <div className="p-2 small text-danger">*Totals include case management</div>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default FundingLevelAmounts;
